class ImagePopup {
  constructor() {
    this.popup = null;
    this.currentIndex = 0;
    this.images = [];
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.initialize();
    this.bindEvents();
  }

  initialize() {
    this.popup = document.getElementById('imagePopup');
  }

  bindEvents() {
    // Get all images with the specified class
    const imageLinks = document.querySelectorAll('.ds-image-link-blocks__image');
    this.images = Array.from(imageLinks).map(img => img.src);

    // Add click event to each image
    imageLinks.forEach((img, index) => {
      img.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.currentIndex = index;
        this.showPopup(img.src);
      });
    });

    // Touch events for swipe
    this.popup.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    }, false);

    this.popup.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    }, false);

    // Close button event
    this.popup.querySelector('.ds-image-popup__close').addEventListener('click', () => {
      this.hidePopup();
    });

    // Navigation events
    this.popup.querySelector('.ds-image-popup__prev').addEventListener('click', () => {
      this.showPrevious();
    });

    this.popup.querySelector('.ds-image-popup__next').addEventListener('click', () => {
      this.showNext();
    });

    // Close on background click
    this.popup.addEventListener('click', (e) => {
      if (e.target === this.popup) {
        this.hidePopup();
      }
    });

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (!this.popup.style.display || this.popup.style.display === 'none') return;
      
      if (e.key === 'Escape') {
        this.hidePopup();
      } else if (e.key === 'ArrowLeft') {
        this.showPrevious();
      } else if (e.key === 'ArrowRight') {
        this.showNext();
      }
    });
  }

  handleSwipe() {
    const swipeThreshold = 50; // minimum distance for swipe
    const swipeDistance = this.touchEndX - this.touchStartX;
    
    if (Math.abs(swipeDistance) > swipeThreshold) {
      if (swipeDistance > 0) {
        // Swipe right - show previous
        this.showPrevious();
      } else {
        // Swipe left - show next
        this.showNext();
      }
    }
  }

  showPopup(imageSrc) {
    const popupImage = this.popup.querySelector('.ds-image-popup__image');
    popupImage.src = imageSrc;
    this.popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  hidePopup() {
    this.popup.style.display = 'none';
    document.body.style.overflow = '';
  }

  showPrevious() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.showPopup(this.images[this.currentIndex]);
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.showPopup(this.images[this.currentIndex]);
  }
}

// Initialize the popup
document.addEventListener('DOMContentLoaded', () => {
  new ImagePopup();
});
